import {css} from 'lit';
export const styles = css`img {
  height: var(--code-tabs-icon-height, 24px);
  width: auto;
}

#tabs {
  display: flex;
  background: var(--code-tabs-tabs-background, hsla(0 100% 100% / 0.9));
  overflow-x: auto;
  justify-content: var(--code-tabs-justify-tabs, start);
}

#tabs button {
  display: flex;
  align-items: center;
  gap: 9px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

#tabs button[selected] {
  background: var(--code-tabs-background, var(--markdown-syntax-background-color, #f6f8fa));
  border-top: 2px solid var(--code-tabs-selected-highlight-color, var(--markdown-link-color));
}

#tabs button[selected]:focus,
#tabs button[selected]:hover {
  color: inherit;
}

#tabs button[selected]::before {
  content: '',;
  z-index: -1,;
  position: absolute;
  left: -100%;
  border-bottom-right-radius: 3px;
  background-color: var(--code-tabs-background, var(--markdown-syntax-background-color, #f6f8fa));
}

#tabs button img:not([src]) {
  display: none;
}

#tabpanel {
  background: var(--code-tabs-tabpanel-background, var(--markdown-syntax-background-color, #f6f8fa));
  border-radius: 3px;
  min-height: var(--code-tabs-min-height, 1px);
}

:host([selected-index="0"]) #tabpanel {
  border-top-left-radius: 0;
}
`;
export default styles;
